import { LedgerAccountsDataTableDocument } from 'generated/resources/datatable.graphql'
import {
  UpdateLedgerAccountDocument,
  UpdateLedgerAccountMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpdateLedgerAccount = () => {
  const [updateLedgerAccount, { loading }] = useMutation(UpdateLedgerAccountDocument, {
    extractorFn: (data) => data.financeMutations.updateFinanceAccount,
  })

  return {
    updateLedgerAccount(variables: UpdateLedgerAccountMutationVariables) {
      return updateLedgerAccount({
        variables,
        refetchQueries: [LedgerAccountsDataTableDocument],
        awaitRefetchQueries: true,
      })
    },
    loading,
  }
}
